import { Injectable } from "@angular/core"
import { AngularFireFunctions } from "@angular/fire/functions"
import { Observable } from "rxjs"

interface AttachSourceInfo {
  source: string
  uid: string
}

interface CustomerInfo {
  customerId: string
}

interface DeleteCardInfo {
  customerId: string
  sourceId: string
}

interface StripeCharge {
  source?: string
  customerId?: string
  amount: number
  uid: string
}

@Injectable({ providedIn: "root" })
export class StripeService {
  private stripeCreateCharge: (charge: StripeCharge) => Observable<void>
  private stripeAttachSource: (sourceInfo: AttachSourceInfo) => Observable<void>
  private stripeGetCustomer: (customerInfo: CustomerInfo) => Observable<any>
  private stripeDeleteSource: (deleteSourceInfo: DeleteCardInfo) => Observable<void>
  private stripeListSources: (customerInfo: CustomerInfo) => Observable<any[]>

  constructor(
    private functions: AngularFireFunctions,
  ) {
    this.stripeCreateCharge = this.functions.httpsCallable<StripeCharge, void>("stripeCreateCharge")
    this.stripeAttachSource = this.functions.httpsCallable<AttachSourceInfo, void>("stripeAttachSource")
    this.stripeGetCustomer = this.functions.httpsCallable<CustomerInfo, any>("stripeGetCustomer")
    this.stripeDeleteSource = this.functions.httpsCallable<DeleteCardInfo, void>("stripeDeleteSource")
    this.stripeListSources = this.functions.httpsCallable<CustomerInfo, any[]>("stripeListSources")
  }

  public async getCustomer(customerId: string): Promise<any> {
    return this.stripeGetCustomer({ customerId }).toPromise()
  }

  public async deleteSource(customerId: string, sourceId: string): Promise<any> {
    await this.stripeDeleteSource({ customerId, sourceId }).toPromise()
  }

  public async createCharge(charge: StripeCharge): Promise<void> {
    return this.stripeCreateCharge(charge).toPromise()
  }

  public async attachSource(sourceInfo: AttachSourceInfo): Promise<void> {
    return this.stripeAttachSource(sourceInfo).toPromise()
  }

  public async listSources(customerId: string): Promise<any> {
    return this.stripeListSources({ customerId }).toPromise()
  }
}
